import type { FaireProductEntity } from "../../entity_types/product";

export const p_darbmubfh4: FaireProductEntity = {
  token: "p_darbmubfh4",
  type: "product",
  name: "H20 Flask Vinyl Sticker Packs assortment",
  brandName: "Top Trenz Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/24520a707b3b2c0238f1ebc6a4351c9d8599486daefb863603284edee5e10433.jpeg",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/98b3db9aaaaee03e0ee7d389413b9146bc29221ab2dce9e1655e53c0977f3274.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
